import React from 'react';
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types";

export default function NotFound({header, content, pathUrl, pathName}) {
    const navigate = useNavigate();
    return (
        <div className="not-found-container">
            <h2 className="not-found-header">{header}</h2>
            <p className="not-found-p">{content}</p>
            <button className="navigate-button not-found-button" onClick={ () => navigate(pathUrl) }> {pathName} </button>
        </div>
    );
}

NotFound.propTypes = {
    header: PropTypes.oneOfType([PropTypes.string]),
    content: PropTypes.oneOfType([PropTypes.string]),
    pathUrl: PropTypes.oneOfType([PropTypes.string]),
    pathName: PropTypes.oneOfType([PropTypes.string])
}